import { render, staticRenderFns } from "./InvoicesAndQuotes.vue?vue&type=template&id=394fe91c"
import script from "./InvoicesAndQuotes.vue?vue&type=script&lang=js"
export * from "./InvoicesAndQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports